import ClientInstance from 'api/ClientInstance';

interface IHttpEndpoints {
  // fetch: (query: any) => Promise<any>;
  fetch: (scope: string) => Promise<any>;
}

const permission: IHttpEndpoints = {
  fetch: (query: any) => ClientInstance.get('/accounts/user_permissions', {
    params: query || {},
  }),
};

export default permission;
